import React, { useEffect } from "react";
import PropTypes from "prop-types";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import {actionCreators} from "./redux/challengerConversionSaga";
import { useDispatch, useSelector } from "react-redux";
import OffersFitter from "./smartComponents/OffersFitter";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import DatePicker from "./smartComponents/DatePicker"
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import FunnelChart from "./smartComponents/FunnelChart"

const ChallengerConversionModule = ({ params }) => {
  const {
    isChartLoading, filtersDirty, datesDirty, isLoading, 
    selectedRequestDates, error, errorText
  } = useSelector(state => state.challengerConversion);
  const dispatch = useDispatch()
  
  const updateData = ()=>{
    if (filtersDirty && !datesDirty) {
      dispatch(actionCreators.fetchCurrentUser({ data:params, updateOnlyChart:true }))
    } else if (datesDirty) {
      dispatch(actionCreators.fetchDataAndFilters({ data:params}))
    }
  }
  const resetData = ()=>{
    dispatch(actionCreators.fetchCurrentUser({ data:params }))
  }

  useEffect(()=>{
    dispatch(actionCreators.fetchCurrentUser({ data:params }))
  }, [])
  
  const content = ()=>{
    return (
      <>
        <div className="edit-selections-bar">

          <div className="select-box">
            <p className="offers-title">Challengers (Select 6 Max)</p>
            <OffersFitter />
          </div>

          <div className="select-box">
            <p className="offers-title">Date Range</p>
            <CustomDateRanges />
          </div>

          <div className="date-select-box multi">
            <p className="offers-title">Date</p>
            <DatePicker />
          </div>

          {filtersDirty ||
          datesDirty &&
          !isLoading &&
          selectedRequestDates.startDate !== "Invalid Date" &&
          selectedRequestDates.endDate !== "Invalid Date" ?
            <button className="submit" onClick={() => updateData()}>
              Update
            </button>
            : null
          }

          {filtersDirty || datesDirty && !isLoading ? (
            <button className="submit reset" onClick={() => resetData()}>
              Reset
            </button>
          ) : null}

        </div>
        
        {isChartLoading
          ? <LoadingAnimation text="Getting fresh data, this may take a moment." />
          : (
            <div>
              {error 
                ? <p className="error error--medium">{errorText}</p> 
                : <FunnelChart />
              }
            </div>
          )
        }
    </>
    )
  } 
  return (
    <SectionToggle 
      isLoading={isLoading}
      title="Challenger Conversion"
      content={content()}
    />
  )
};

ChallengerConversionModule.propTypes = { params: PropTypes.object }

export default ChallengerConversionModule;